import { Layout } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<typeof Layout>

export const ContainerLayout: FC<Props> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Layout {...props} className={clsx(['w-full', className])}>
      {children}
    </Layout>
  )
}
